import { render, staticRenderFns } from "./FormSchema.vue?vue&type=template&id=014f5837"
import script from "./FormSchema.vue?vue&type=script&lang=js"
export * from "./FormSchema.vue?vue&type=script&lang=js"
import style0 from "./FormSchema.vue?vue&type=style&index=0&id=014f5837&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports